/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { IJobs } from '../../Jobs/Components/JobView/JobsView';

export interface FacilityInterface extends IJobs {
  buildingName: string;
  mdFacilityType: string;
  totalBusiness?: number;
  ongoingJobs?: number;
  address: AddressInterface;
  facilityId: string;
}
export interface CompanyUserInterface extends IJobs {
  username: string;
  email: string;
  phoneNumber: string;
  roles: Role[];
  facility: string;
  userId: string;
}

export interface CompanyUserViewInterface extends IJobs {
  userId: string;
  organizationId: string;
  roleId: string;
  customerId: string;
  mdCountryCode: string;
  regionId: string;
  subRegionId: string;
  facilityId: string;
}

export interface Role {
  roleName: string;
  roleId: string;
}

export interface MetaDataInterface {
  limit: number;
  pageIndex: number;
  totalCount: number;
}

export interface AddressInterface {
  addressName: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  county: string;
  postalCode: string;
  stateCode: string;
  state: string;
}

export interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const FIELD_TYPES = {
  email: 'email',
  username: 'username',
} as const;

export interface Roles {
  roleName: string;
}

export interface UserState {
  rowInfo: {
    username: string;
    roles: Roles[];
    email?: string;
    phoneNumber?: string;
    intId?: number;
    organizationId?: string;
    userId?: string;
  };
}
